var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { FixedInt } from './FixedInt';
var HexColor = /** @class */ (function (_super) {
    __extends(HexColor, _super);
    function HexColor() {
        var _this = _super.call(this) || this;
        _this._fixedInt = new FixedInt(2);
        return _this;
    }
    HexColor.prototype.encodeBuffer = function (hex, buffer) {
        if (hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/)) {
            hex = '#' + RegExp.$1 + RegExp.$1 + RegExp.$2 + RegExp.$2 + RegExp.$3 + RegExp.$3;
        }
        if (!/^#[0-9a-f]{6}$/.test(hex)) {
            throw new TypeError('Hex color must be # and 3 or 6 hex symbols, but received ' + hex);
        }
        var fixedInt = this._fixedInt;
        // @ts-ignore
        hex.substr(1).replace(/.../g, function (part) {
            fixedInt.encodeBuffer(parseInt(part, 16), buffer);
        });
    };
    HexColor.prototype.decodeBuffer = function (buffer) {
        var hexParts = [];
        for (var i = 0; i < 2; i++) {
            var part = this._fixedInt.decodeBuffer(buffer).toString(16);
            while (part.length < 3) {
                part = '0' + part;
            }
            hexParts.push(part);
        }
        return '#' + hexParts.join('');
    };
    return HexColor;
}(Type));
export { HexColor };
